import { CoBrands, SubBrands } from '@/configuration/sources/Brands.yml'
import { allowedBrands as googlePayBrands } from '@/configuration/sources/smartform/googlePay.yml'
import { allowedBrands as applePayBrands } from '@/configuration/sources/smartform/applePay.yml'
import { allowedBrands as samsungPayBrands } from '@/configuration/sources/smartform/samsungPay.yml'

const defaultNetworks = {
  GOOGLEPAY: googlePayBrands,
  APPLE_PAY: applePayBrands,
  SAMSUNG_PAY: Object.keys(samsungPayBrands)
}

function getAllowedBrandsFromNetworks({
  dnaBrands,
  paymentMethod,
  dnaMetadataCards,
  disableVisaOnWallet,
  CBEnabled
}) {
  if (!dnaBrands) return []

  // If DNA metadata.cards exists and is not empty, use it instead of hardcoded config
  if (dnaMetadataCards && dnaMetadataCards.length > 0) {
    // Create a Set of allowed brands from metadata.cards
    // This includes both the original brands and their transformations
    const allowedBrandsSet = new Set()

    dnaMetadataCards.forEach(card => {
      // Add the original card
      allowedBrandsSet.add(card)

      // Add transformed version if it's a CoBrand (e.g., CB_NATIONALE -> CB)
      if (CoBrands.brands[card]) {
        allowedBrandsSet.add(CoBrands.brands[card])
      }

      // Add transformed version if it's a SubBrand (e.g., VISA_DEBIT -> VISA)
      if (SubBrands[card]) {
        allowedBrandsSet.add(SubBrands[card])
      }
    })

    if (disableVisaOnWallet) {
      allowedBrandsSet.delete('VISA')
    }

    // Filter dnaBrands to only include brands in the allowed set
    return dnaBrands.filter(brand => allowedBrandsSet.has(brand))
  }

  // Fallback to hardcoded config if no metadata.cards (backward compatibility)
  const allowedNetworks = new Set(defaultNetworks[paymentMethod])

  if (paymentMethod === 'GOOGLEPAY' && CBEnabled) allowedNetworks.add('CB')

  if (disableVisaOnWallet) {
    allowedNetworks.delete('VISA')
  }

  return dnaBrands.filter(
    brand =>
      allowedNetworks.has(brand) ||
      allowedNetworks.has(CoBrands.brands[brand]) ||
      allowedNetworks.has(SubBrands[brand])
  )
}

export default getAllowedBrandsFromNetworks
